import React, { useCallback, useState } from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { usePageStartBootstrap } from '../hooks/use_page_start_bootstrap';
import { processError } from '../utils/base_error';
import { useDependencyInjection } from '../../config/di/dependency_injection_context';
import { usePageLoader } from '../contexts/page_content_context';
import { NomeAuditorDropDown } from '../domain/models/nome_auditor_dropdown';



type Props = {
  name: string; 
  label?: string;
  newButtonLabel?: string;
  required?: boolean;
  readOnly?: boolean;
  placeholder?: string;
  disabled?: boolean;
  value: string | number | null | undefined; 
  onChange: (newValue: string | number | undefined) => void;
  error?: boolean;
  helperText?: string | null;
};

export const DefaultNomeAuditor = ({
  name, 
  label,
  newButtonLabel,
  required,
  readOnly,
  placeholder,
  disabled, 

 
  value,
  onChange,
  error,
  helperText,

}: Props) => {

  const { pushErrorNotification, pushInfoNotification } = usePageLoader();
  const [nomeAuditorDropDown, setNomeAuditorDropDown] = useState<NomeAuditorDropDown[]>([]);

  const {
    commons: {
      getNomeAuditorDropDownUseCase,
    },
  } = useDependencyInjection();

  const loadFornecedorDropDown = useCallback(async () => {
    try {
      const result = await getNomeAuditorDropDownUseCase.getNomeAuditorDropDown();
      setNomeAuditorDropDown(result);
    } catch (e: unknown) {
      pushErrorNotification('Error', processError(e, 'Falha ao buscar nomes do auditores!'));
    }
  }, [getNomeAuditorDropDownUseCase, pushErrorNotification]);

  usePageStartBootstrap(async () => {
    loadFornecedorDropDown();
  });


  return (
    <>
      <Autocomplete
        fullWidth={true}
        size="small"
        disablePortal
        options={nomeAuditorDropDown}
        getOptionLabel={(opt) => opt.nomeAuditor}
        isOptionEqualToValue={(opt, val) => opt.idAuditor === val.idAuditor}
        sx={{ minHeight: 45 }}
        readOnly={readOnly}
        disabled={disabled} 
        value={nomeAuditorDropDown.find(x => x.idAuditor === value) ?? null}
        onChange={(_, newValue) => {
          onChange(newValue ? newValue.idAuditor : undefined);
        }}
        
        renderInput={(params) => (
          <TextField
            {...params}
            size="small"
            label={label}
            error={error} 
            helperText={helperText}
            
            placeholder={placeholder}
            required={required}
          />
        )}
      />
    </>
  );
};